import type { Logger } from "@expert/logging";

import ky from "ky";

import type { GeneratePasscodeResult } from "./generatePasscode";
import type { DefaultPayload } from "./types";

import { defaultHeaders, defaultTimeoutInMS } from "../types";

type GeneratePasscodeForVerificationPayload = DefaultPayload & {
    targetMdn: string;
};

export const generatePasscodeForVerification = async (
    ssoAccessToken: string,
    payload: GeneratePasscodeForVerificationPayload,
    logger: Logger,
) => {
    try {
        const url = `${import.meta.env.VITE_API_BASE_URL}/api/device-activation/v1/verify-customer/generate-otp`;
        const resp = await ky.post(url, {
            headers: {
                ...defaultHeaders,
                Authorization: `Bearer ${ssoAccessToken}`,
            },
            json: payload,
            timeout: defaultTimeoutInMS,
        });

        const result = await resp.json<GeneratePasscodeResult>();
        return result;
    } catch (error) {
        logger.warn({ error }, `Error: Could not send verification OTP to customer.`);
        return { success: false, transactionId: "" };
    }
};
